import { HttpClient } from '@angular/common/http';
import { inject } from '@angular/core';
import { ENVIRONMENT, PIMSEnvironment } from 'environments';

export class PimsFrontendLoginParametersEndpoint {
  private env = inject<PIMSEnvironment>(ENVIRONMENT);
  http = inject(HttpClient);

  get(polling?: boolean) {
    return this.http.get<any>(
      `${this.env.constants.API_URL}/content/web/frontendLoginParameters${polling ? '?polling=true' : ''}`,
    );
  }
}
